export default __webpack_public_path__ + "static/media/ac_mode_dry_active.ad40a31c.svg";